var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingLogo"},[_c('img',{attrs:{"src":"/assets/img/logo/charity-logo.png","alt":"children's heart logo"}})])
}]

export { render, staticRenderFns }